import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ModalVideo from 'react-modal-video';

import Lquote from './../../public/img/l_quote.png';
import jeremiah from './../../public/img/testimonial/jeremiah.png';
import maheshwari from './../../public/img/testimonial/maheshwari.jpg';
import elizabeth from './../../public/img/testimonial/elizabeth.png';
import karen from './../../public/img/testimonial/karen.jpg';
import tsoai from './../../public/img/testimonial/tsoai.png';
import meena from './../../public/img/testimonial/meena.jpg';
import pulane from './../../public/img/testimonial/pulane.png';
import rama from './../../public/img/testimonial/rama.jpg';


const items = [
    {
      id: 1,
      type:"video",
      src:maheshwari,
      urlstr:'RGZ8kSxUi8Y',
      caption: "Ms Maheshwari Natarajan",
      occupation: "Principal, Vidya Mandir Estancia",
      header: ` We find that most times we are delivering concepts through the chalk and talk 
      method but HeyMath has allowed us to experiment with activities and experiment with digital 
      solutions for delivering concepts.`,
      altText: "Ms Maheshwari Natarajan"
    },
    {
        id: 2,
        type:"image",
        src:jeremiah,
        urlstr:'none',
        caption: "Jeremiah",
        occupation: "Qifa Primary School, Singapore",
        header: ` I had the chance to utilize the HeyMath! resources and that brought excitements
        and squeals of joy among the pupils too. It was indeed an experience as the pupils were
        really very enthusiastic and warm. They were interested in learning and were participating 
        actively in the lesson.`,
        altText: "Jeremiah"
    },
    {
        id: 3,
        type:"image",
        src:elizabeth,
        urlstr:'none',
        caption: "Elizabeth Ng",
        occupation: "CHIJ Katong Convent, Singapore",
        header: ` I never knew that so much work has to go into developing 
        just one ICT lesson that we see in a Learning Management System. 
        HeyMath! had indeed enhanced my professional development and provided a 
        global perspective about education.`,
        altText: "Elizabeth Ng"
    },
    {
        id: 4,
        type:"video",
        src:karen,
        urlstr:'MMbIMB1eQ9U',
        caption: "Karen Dickey",
        occupation: "Middle School Math Coordinator for Westport Schools, CT",
        header: ` We’ve worked together with the people here to create the lessons 
        and to come up with new and exciting ways of approaching Mathematics.`,
        altText: "Karen Dickey"
    },
    {
        id: 5,
        type:"video",
        src:meena,
        urlstr:'c3Z2ty6gwv4',
        caption: "Ms. Meena Mayyappan", 
        occupation: "Correspondent/ Director Academics, Honey Bunch School",
        header: `I think this will definitely help the children. Because now Math is not taught, it is again 
        like memorising and it is more without understanding that children are doing. So, with this children I 
        feel would have an understanding.`,
        altText:"Ms. Meena Mayyappan"
    },
    {
        id: 6,
        type:"video",
        src:rama,
        urlstr:'jKx6LKHFIqs',
        caption: "Ms.N Rama Devi", 
        occupation: "Teacher, Vidya Niketan Public School, Coimbatore",
        header: `It is really useful. It’s not coming from the lips, 
        it’s coming from the heart. Definitely children will be benefited if used constructively.`,
        altText:"Ms.N Rama Devi"
    }
];


// {
//   id: 5,
//   type:"image",
//   src:tsoai,
//   urlstr:'none',
//   caption: "Tsoai",
//   occupation: "Free State Province, South Africa",
//   header: `I found the team capable and professional in their development of high quality material that 
//   will be used in our schools. The process that each lesson goes through before it becomes a final product, 
//   is of a high standard! This was a real Aha! experience for me.`,
//   altText:"Tsoai"
// },
// {
//   id: 7,
//   type:"image",
//   src:pulane,
//   urlstr:'none',
//   caption: "Pulane Phala", 
//   occupation: "Free State Province, South Africa",
//   header: `I cherish the co-founder of this programme and her team for their willingness 
//   to share their intelligent ideas to benefit us as officials and teachers and most importantly 
//   to benefit the schools in South Africa.`,
//   altText:"Pulane Phala"
// },

class TeacherTestimonial extends PreLoginSessionCheck {
  constructor(props) {
    super(props);
    this.state = {
		  isOpen: false
		}
		this.openModal = this.openModal.bind(this)
		this.goNext = this.goNext.bind(this)
    	this.goPrev = this.goPrev.bind(this)
  }

	openModal (someValue) {
	    this.setState({isOpen: true})
	    this.videoId = someValue
	}

	goNext() {
	    if (this.swiper) this.swiper.slideNext()
	}
	 
	goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	}

  loadimage(item){
   if(item.type=="image"){
    return (
      <figure className="figure">
      <img src={item.src} className="figure-img img-fluid rounded" alt={item.altText}></img>
      <figcaption className="figure-caption"><div className="txtcaption">
        {item.caption}
        </div>
        <div className="txtoccupation">
        {item.occupation}
        </div></figcaption>
    </figure>
    )
   }else{
    return (
      <figure className="figure">
      <div onClick={this.openModal.bind(null,item.urlstr)}> 
      <img src={item.src} className="figure-img img-fluid rounded videoimg" alt={item.altText}></img>
      <span className="play-btn"></span>
      </div>
      <figcaption className="figure-caption"><div className="txtcaption">
        {item.caption}
        </div>
        <div className="txtoccupation">
        {item.occupation}
        </div></figcaption>
    </figure>
    )
   }
  }

    render() {
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight:true,
        autoplay:true,
        autoplaySpeed:3000,
        pauseOnHover:true
      };

      return (
       <div id="OurparFBSlider" className="mtb our-student">
<div className="container justify-content-md-center">
<h4>What teachers have to say about HeyMath!</h4> 
<div className="stud-cont">
          <Slider {...settings}>
          {(() => {
											return(
                        items.map((fbcomm, index) =>
                      <div className="fbcont" key={index}>
											
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 txtcont">

                      <div className="txtpart">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 test-pic">
                             
                             {this.loadimage(items[index])}
                             
                        </div>

                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 test-cont">
                        <div className="txtimg">   
                        <img src={Lquote} />
                        </div>

                            <div className="txtheader">
                            {items[index].header}
                            </div>
                          </div>

                      </div>


														</div>
                             </div>
													)
											);											

									})()}			

      </Slider>
      </div>
          </div>
          <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
       </div>

      );
    }
  }




export default TeacherTestimonial;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/TeacherTestimonial.js